export const ROUND_RECOMMENDATIONS = [
  { value: 'hire', label: 'Proceed / Hire' },
  { value: 'hold', label: 'Hold' },
  { value: 'no-hire', label: 'Do not proceed' }
];

export function emptyRoundFeedback() {
  return {
    recommendation: '',
    technicalRating: '',
    communicationRating: '',
    cultureFitRating: '',
    overallScore: '',
    strengths: '',
    concerns: '',
    summary: ''
  };
}

const defaultRoundName = idx => `Interview ${idx + 1}`;

export function defaultJobInterviewRounds() {
  return [{ id: 'round-1', name: 'Interview', order: 1 }];
}

/** Build round rows from count, preserving existing names where possible. */
export function buildInterviewRoundsFromCount(count, existing = []) {
  const n = Math.max(1, Math.min(10, Number(count) || 1));
  if (n === 1) {
    const first = existing[0];
    return [
      {
        id: first?.id || 'round-1',
        name: String(first?.name || 'Interview').trim() || 'Interview',
        order: 1
      }
    ];
  }
  return Array.from({ length: n }, (_, idx) => {
    const prev = existing[idx];
    const defaultName = defaultRoundName(idx);
    return {
      id: prev?.id || `round-${idx + 1}`,
      name: String(prev?.name || defaultName).trim() || defaultName,
      order: idx + 1
    };
  });
}

export function normalizeJobRoundsForm(rounds) {
  if (!Array.isArray(rounds) || !rounds.length) {
    return [{ id: `round-${Date.now()}`, name: 'Interview', order: 1 }];
  }
  return rounds.map((r, idx) => ({
    id: r.id || `round-${Date.now()}-${idx}`,
    name: String(r.name || defaultRoundName(idx)).trim(),
    order: idx + 1
  }));
}
